import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import { useSEO } from '@/hooks/useSEO';

export default function NotFound() {
  useSEO({
    title: '页面走丢了 — 404 | 西瓜黑料',
    description: '你访问的页面不存在或已调整地址，返回瓜田总览继续追你想看的时间线。',
    path: '/',
  });

  return (
    <section className="px-4 pb-24 pt-28 md:px-8">
      <div className="mx-auto max-w-2xl">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '页面走丢了' }]} />
        <div className="mt-6 rounded-lg border border-background-200 bg-background-50 px-6 py-20 text-center">
          <span className="font-heading text-6xl font-bold text-background-300">404</span>
          <h1 className="mt-5 font-heading text-2xl font-bold text-foreground-950">
            这口瓜走丢了
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            页面可能已经调整过地址，或者从未存在。回瓜田里再挑一出接着追吧。
          </p>
          <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex h-11 items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              返回首页
            </Link>
            <Link
              to="/dramas"
              className="inline-flex h-11 items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              去瓜田总览
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}